export var ThemeId;
(function (ThemeId) {
    ThemeId["Default"] = "@gr/ui-neo-default-theme";
    ThemeId["HighContrast"] = "@gr/ui-neo-high-contrast";
})(ThemeId || (ThemeId = {}));
